import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import productData, { siteConfig } from "../Datas/productData";
import { ProductCard } from "./Shop";
import "../css/main.scss";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function CampaignImage({ src, fallback, alt, className = "" }) {
  const handleImageError = (event) => {
    if (fallback && !event.currentTarget.dataset.fallbackApplied) {
      event.currentTarget.dataset.fallbackApplied = "true";
      event.currentTarget.src = fallback;
    }
  };

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      onError={handleImageError}
    />
  );
}

function Main() {
  const featuredProducts = [
    ...productData.filter((product) => product.featured),
    ...productData.filter((product) => !product.featured),
  ]
    .filter(
      (product, index, products) =>
        products.findIndex((item) => item.id === product.id) === index
    )
    .slice(0, 6);

  return (
    <main className="home" id="main-content">
      <section className="home__masthead" aria-labelledby="home-title">
        <h1 id="home-title">{siteConfig.brandName}</h1>
      </section>

      <section className="home__campaigns" aria-label="Seasonal collections">
        <Link
          className="home__campaign home__campaign--women"
          to="/shop?gender=Women"
          onClick={scrollToTop}
        >
          <CampaignImage
            src="/main/home-women.png"
            alt="Woman wearing a sage jacket and dark trousers in a sunlit studio"
          />
          <span className="home__campaign-copy">
            <strong>Women's Autumn collection</strong>
            <span className="home__campaign-cta" aria-hidden="true">
              <FiArrowRight />
            </span>
          </span>
        </Link>

        <Link
          className="home__campaign home__campaign--men"
          to="/shop?gender=Men"
          onClick={scrollToTop}
        >
          <CampaignImage
            src="/main/home-men.png"
            alt="Man wearing a navy overshirt and relaxed trousers in a design studio"
          />
        </Link>
      </section>

      <section className="home__wide-editorial" aria-label="Autumn 2026 collection">
        <Link to="/shop" onClick={scrollToTop} aria-label="Shop Autumn 2026">
          <CampaignImage
            src="/main/home-hero.png"
            alt="Models wearing the latest womenswear and menswear collection"
          />
          <span className="home__wide-copy">
            <strong>Autumn 2026</strong>
            <span className="home__campaign-cta" aria-hidden="true">
              <FiArrowRight />
            </span>
          </span>
        </Link>
      </section>

      <section className="home__new" aria-labelledby="new-arrivals-title">
        <div className="home__section-heading">
          <h2 id="new-arrivals-title">New arrivals</h2>
          <Link to="/shop" onClick={scrollToTop}>
            View all
          </Link>
        </div>
        <div className="home__product-grid">
          {featuredProducts.map((product, index) => (
            <ProductCard key={product.id} product={product} eager={index < 2} />
          ))}
        </div>
      </section>

      <nav className="home__departments" aria-label="Shop by department">
        <Link to="/shop?category=Outerwear" onClick={scrollToTop}>
          Outerwear
        </Link>
        <Link to="/shop?category=Knitwear" onClick={scrollToTop}>
          Knitwear
        </Link>
        <Link to="/shop?category=Bags" onClick={scrollToTop}>
          Bags
        </Link>
        <Link to="/shop?category=Shoes" onClick={scrollToTop}>
          Shoes
        </Link>
      </nav>
    </main>
  );
}

export default Main;
